import {useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../_metronic/helpers'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import {Fade, IconButton, Menu, MenuItem, Tooltip} from '@mui/material'
import {deleteFileSelling} from '../modules/report/apis/formAPIs'
import {deleteFile} from '../modules/risk/api'
import {downloadBase64File} from '../utils/DownloadFileBase64'

type Props = {
  folderName: string
  folderType: string
  id: any
  parentId: any
  refId: any
  status: any
  urlFile?: string
  hideFolder?:any
  handleFolderClicked: (
    id: any,
    parentId: any,
    folderName: string,
    search: boolean,
    refId?: any,
  ) => void
  handleFolderDeleted: (deleted: any) => void
}

const ITEM_HEIGHT = 48

export const FolderCustom = ({
  folderName,
  folderType,
  id,
  parentId,
  refId,
  handleFolderClicked,
  handleFolderDeleted,
  status,
  urlFile,
  hideFolder,
}: Props) => {
  const [filePath, setFilePath] = useState('/media/svg/files/folder-document.svg')
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const options = ['Tải xuống', 'Xoá']
  const openMenu = Boolean(anchorEl)
  const handleClickOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleCloseMenu = (action: string) => {
    setAnchorEl(null)
    if (action == 'Xoá') handleDeleteFile()
    if (action == 'Tải xuống') downloadFile()
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  const handleRightClick = (e: any) => {
    e.preventDefault()
    handleClickOpenMenu(e)
  }

  function downloadFile() {
    if (urlFile) {
      switch (folderType) {
        case '.jpg':
        case '.png':
        case '.jpeg':
          downloadBase64File("data:image/" + folderType.replace(".", ""), urlFile, folderName)
          break
        case '.svg':
          downloadBase64File("data:image/svg+xml" + folderType.replace(".", ""), urlFile, folderName)
          break
        default:
          downloadBase64File("data:application/" + folderType.replace(".", ""), urlFile, folderName)
          break
      }
    }
  }

  const handleDeleteFile = () => {
    if (folderType) {
      deleteFileSelling(id)
        .then((res: any) => {
          handleFolderDeleted(res)
          return
        })
        .catch((error) => {
          handleFolderDeleted(error)
          return
        })
    } else {
      deleteFile(id)
        .then((res: any) => {
          handleFolderDeleted(res)
          return
        })
        .catch((error) => {
          handleFolderDeleted(error)
          return
        })
    }
  }

  useEffect(() => {
    switch (folderType) {
      case '.doc':
      case '.docx':
        setFilePath('/media/svg/files/doc.svg')
        break
      case '.pdf':
        setFilePath('/media/svg/files/pdf.svg')
        break
      case '.xlsx':
        setFilePath('/media/svg/files/excel.svg')
        break
      case '.svg':
      case '.jpg':
      case '.png':
      case '.jpeg':
        setFilePath('/media/svg/files/image.png')
        break
      default:
        break
    }
  }, [folderType])

  useEffect(() => {
    if (!status) return
    if (status == 2) setFilePath('/media/svg/files/folder-document.svg')
    else setFilePath('/media/svg/files/folder-check.svg')
  }, [status])

  return (
    <div
      className='folder-component-wrapper'
      onDoubleClick={() => handleFolderClicked(id, parentId, folderName, true, refId)}
      onContextMenu={handleRightClick}
    >
      <div className='folder-component'>
        <img alt='' className='h-20px' src={toAbsoluteUrl(filePath)} />
        <Tooltip
          sx={{fontSize: '14px'}}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
          TransitionProps={{timeout: 600}}
          onOpen={handleOpen}
          title={folderName}
        >
          <label className='text'>{folderName}</label>
        </Tooltip>
        <IconButton
          aria-label='more'
          id='long-button'
          aria-controls={openMenu ? 'long-menu' : undefined}
          aria-expanded={openMenu ? 'true' : undefined}
          aria-haspopup='true'
          onClick={handleClickOpenMenu}
          sx={{width: '1em', height: '1em'}}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id='long-menu'
          MenuListProps={{
            'aria-labelledby': 'long-button',
          }}
          anchorEl={anchorEl}
          open={openMenu}
          onClose={handleCloseMenu}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: '20ch',
            },
          }}
        >
          {options.map((option) => (
            <MenuItem
              key={option}
              selected={option === 'Pyxis'}
              onClick={() => handleCloseMenu(option)}
            >
              {option}
            </MenuItem>
          ))}
        </Menu>
      </div>
      {urlFile && !hideFolder&&
        (folderType == '.svg' ||
          folderType == '.jpg' ||
          folderType == '.png' ||
          folderType == '.jpeg') && (
          <div className='folder-component-image'>
            <img
              src={'data:image/png;base64, ' + urlFile}
              style={{height: '180px', objectFit: 'cover'}}
              alt=''
            />
          </div>
        )}
      {urlFile && !hideFolder&&
        (folderType == '.doc' ||
          folderType == '.docx' ||
          folderType == '.xlsx' ||
          folderType == '.pdf') && (
          <div className='folder-component-image'>
            <img
              src={toAbsoluteUrl(filePath)}
              style={{height: '180px', objectFit: 'cover'}}
              alt=''
            />
          </div>
        )}
    </div>
  )
}
